import styled, { keyframes } from "styled-components";
import { theme } from "../../theme";

export const Spinner = () => {
  return (
    <SpinnerWrapper>
      <SpinnerElement />
    </SpinnerWrapper>
  );
};

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
`;

const SpinnerElement = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-top: 5px solid ${theme.color.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
